import { useLocalObservable } from 'mobx-react-lite';
import { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import Entities from 'STORE';

import { ICallInvitationPresenter, ViewType } from './CallInvitation.types';

export const useCallInvitationPresenter = (): ICallInvitationPresenter => {
  const params = useParams<{ channelId: string }>();

  const presenter = useLocalObservable<ICallInvitationPresenter>(() => ({
    currentView: ViewType.JoinView,

    setView(view: ViewType): void {
      presenter.currentView = view;
    },
  }));

  useLayoutEffect(() => {
    Entities.callInvitation.setChannelId(params.channelId!);
  }, []);

  return presenter;
};
